import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, AlertTriangle, Users, Search, Plus, Heart } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  const path = location.pathname;

  const navItems = [
    { path: '/', icon: Home, label: 'होम' },
    { path: '/missing', icon: AlertTriangle, label: 'लापता' },
    { path: '/submit', icon: Plus, label: 'रिपोर्ट', isFab: true },
    { path: '/unknown', icon: Users, label: 'अज्ञात' },
    { path: '/shokh-sandesh', icon: Heart, label: 'श्रद्धांजलि' },
  ];

  const isActive = (itemPath) => {
    if (itemPath === '/') return path === '/';
    return path.startsWith(itemPath);
  };

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <div className="flex items-center justify-around py-2 px-4">
        {navItems.map((item) => (
          item.isFab ? (
            <Link
              key={item.path}
              to={item.path}
              className="fab-button -mt-8"
              data-testid="nav-report-fab"
            >
              <item.icon className="w-6 h-6" strokeWidth={2.5} />
            </Link>
          ) : (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center py-2 px-3 relative"
              data-testid={`nav-${item.label}`}
            >
              <div className="relative">
                <item.icon 
                  className={`w-6 h-6 transition-all duration-300 ${
                    isActive(item.path) 
                      ? 'text-red-600 scale-110' 
                      : 'text-gray-400'
                  }`}
                  strokeWidth={isActive(item.path) ? 2.5 : 1.5}
                />
                {isActive(item.path) && (
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-red-600 rounded-full" />
                )}
              </div>
              <span className={`text-xs mt-1 transition-colors ${
                isActive(item.path) ? 'text-red-600 font-semibold' : 'text-gray-400'
              }`}>
                {item.label}
              </span>
            </Link>
          )
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
